<script setup lang="ts"></script>
<template>
  <RouteParamDialog show-close title="AxonIQ Console Developer Plan" param="plan-dialog" param-value="developer">
    <SubscriptionFormDeveloper/>
  </RouteParamDialog>
  <RouteParamDialog show-close title="AxonIQ Console Professional Plan" param="plan-dialog" param-value="professional">
    <SubscriptionFormPro/>
  </RouteParamDialog>
  <RouteParamDialog show-close title="Get In touch" param="plan-dialog" param-value="enterprise">
    <SubscriptionFormEnterprise/>
  </RouteParamDialog>
</template>

<style scoped>
</style>
